
<template>
  <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> 
  <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
      <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
  </v-snackbar>
  <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
    <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
  </v-snackbar>
  <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
      <template >
        <v-toolbar flat class="rounded-lg">
              <v-toolbar-title style="margin-left: 20px;"><v-icon class="mx-2">mdi-notebook-outline</v-icon> {{ this.$store.state.title }}</v-toolbar-title> 
              <v-spacer></v-spacer>
              <v-flex lg3>
                <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
              </v-flex> 
              <!-- v dialog  -->
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    outlined
                    rounded
                    small
                    color="primary"
                    dark
                    class="mb-2" 
                    v-bind="attrs"
                    v-on="on"
                    >
                    Add new topic
                    <v-icon class="ml-2">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card>
                    <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
                    <v-card-text class="overflow-card" style="height: 500px;overflow-y: auto;">
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field outlined dense v-model="editedItem.topicname" label="Topic Name">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-select label="Status" dense outlined 
                            :items="status_topic_insert" 
                            item-text="name_topic" 
                            item-value="value_topic" 
                            v-model="topicstatus_topic" 
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                  <!-- v for dinamis / -->
                          <v-row class="ma-0 pa-0" v-for="(item, index) in item_insert_dinamis" :key="index">
                            <v-flex lg8>
                              <v-text-field outlined dense v-model="item.keywordname" label="Keywords"></v-text-field>
                            </v-flex>
                            <v-flex lg4>
                              <v-btn class="mx-2 elevation-0" @click="add" dark outlined icon color="#0471A5"><v-icon>mdi-plus</v-icon></v-btn>
                              <v-btn class="elevation-0"  @click="remove(item, index)" outlined color="#0471A5" icon><v-icon>mdi-minus</v-icon></v-btn>
                            </v-flex>
                          </v-row>
                    <!-- end v for dinamis / -->
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-select label="Seen Privilege" dense outlined 
                            :items="privilege_insert" 
                            item-text="name_privilege_insert" 
                            item-value="value_privilege_insert" 
                            v-model="editedItem.topicstatus" ></v-select>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  
                    <v-divider></v-divider>
                    <v-card-actions class="py-3">
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                        Cancel
                      </v-btn>
                      <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense @click="saveinsert">
                        Save 
                      </v-btn>
                    </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- dialog informasi topic  -->
              <v-dialog v-model="dialoginformasitopic" max-width="700px">
                <v-card>
                  <v-card-title>
                    <span class="text-h6">Topic</span>
                  </v-card-title>
                  <v-card-text>
                    <v-list-item>
                      <v-list-item-avatar color="#EDF4FB">
                        <v-icon color="#439EDF" dark>
                          mdi-account-outline
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>Created By</v-list-item-title>
                        <v-list-item-subtitle>{{createnametopic}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider inset></v-divider>
                    <v-list-item>
                      <v-list-item-avatar color="#EDF4FB">
                        <v-icon color="#439EDF" dark>
                          mdi-clock-outline
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>Created Date</v-list-item-title>
                        <v-list-item-subtitle>{{createdatetopic}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider inset></v-divider>
                    <v-list-item>
                      <v-list-item-avatar color="#EDF4FB">
                        <v-icon color="#439EDF" dark>
                          mdi-account-reactivate-outline
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>Update By</v-list-item-title>
                        <v-list-item-subtitle>{{updatenametopic}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider inset></v-divider>
                    <v-list-item>
                      <v-list-item-avatar color="#EDF4FB">
                        <v-icon color="#439EDF" dark>
                          mdi-history
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>Update Date</v-list-item-title>
                        <v-list-item-subtitle>{{updatedatetopic}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider inset></v-divider>
                  </v-card-text>
                  <v-card-actions class="py-3">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="closeInformasiTopicDialog">
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- dialog informasi topic end  -->
              <v-dialog v-model="dialogedittopic" max-width="500px">
                <v-card>
                  <v-card-title><span class="text-h6">Update Topic</span></v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field outlined dense v-model="editedItem.topicname" label="Topic Name">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-select label="Keyword Status" dense outlined 
                          :items="keywordstatusselect" 
                          item-text="name" 
                          item-value="value" 
                          v-model="topicstatus" 
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                    <v-card-actions class="py-3">
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="closeTopicDialog">
                        Close
                      </v-btn>
                      <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense @click="saveedittopic">
                        Save
                      </v-btn>
                    </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- end dialog edit topic  -->
              <!-- dialog keyword  -->
              <!-- informasi keyword  -->
              <v-dialog v-model="dialoginformasikeyword" max-width="500px">
                <v-card>
                  <v-card-title><span class="text-h6">Keyword</span></v-card-title>
                  <v-card-text>
                    <v-list-item>
                      <v-list-item-avatar color="#EDF4FB">
                        <v-icon color="#439EDF" dark>
                          mdi-account-outline
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>Created By</v-list-item-title>
                        <v-list-item-subtitle>{{createnamekeyword}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider inset></v-divider>
                    <v-list-item>
                      <v-list-item-avatar color="#EDF4FB">
                        <v-icon color="#439EDF" dark>
                          mdi-clock-outline
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>Created Date</v-list-item-title>
                        <v-list-item-subtitle>{{createdatekeyword}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider inset></v-divider>
                    <v-list-item>
                      <v-list-item-avatar color="#EDF4FB">
                        <v-icon color="#439EDF" dark>
                          mdi-account-reactivate-outline
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>Update By</v-list-item-title>
                        <v-list-item-subtitle>{{updatenamekeyword}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider inset></v-divider>
                    <v-list-item>
                      <v-list-item-avatar color="#EDF4FB">
                        <v-icon color="#439EDF" dark>
                          mdi-history
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>Update Date</v-list-item-title>
                        <v-list-item-subtitle>{{updatedatekeyword}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider inset></v-divider>
                  </v-card-text>
                  <v-card-actions class="py-3">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="closeInformasikeywordDialog">
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogeditkeyword" :max-width="width_form_keyword" max-height="auto">
                <v-card>
                  <v-card-title><span class="text-h6">Update Keyword</span> 
                    <span class="name_topic">Topic: {{ name_topic_dialog }}</span> </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-flex lg7>
                        </v-flex>
                        <v-flex lg5>
                            
                            <v-text v-show=collect_news_val style="margin-left: 18px !important;" >
                              <v-icon> mdi-web</v-icon>
                            </v-text>
                            <v-text  v-show=collect_twit_val style="margin-left: 29px !important;">
                              <v-icon>mdi-twitter</v-icon>
                            </v-text>
                            
                            <v-text v-show=collect_ytb_val style="margin-left: 28px !important;">
                              <v-icon>mdi-youtube</v-icon>
                            </v-text>
                            
                            <v-text v-show=collect_tiktok_val style="margin-left: 29px !important;">
                              <v-icon>fa-brands fa-tiktok</v-icon>
                            </v-text>
                            
                            <v-text v-show=collect_ig_val style="margin-left: 29px !important;">
                              <v-icon>mdi-instagram</v-icon>
                            </v-text>

                            <v-text v-show=collect_ig_val style="margin-left: 29px !important;">
                              <v-icon>mdi-facebook</v-icon>
                            </v-text>
                        </v-flex>
                      <!-- v for dinamis / -->
                        <v-row class="ma-0 pa-0 ml-3 mt-2" v-for="(item, index) in item_edit_keyword_dinamis" :key="index">
                          <v-flex lg7>
                            <v-text-field outlined dense v-model="item.keywordname" label="Keywords"  :disabled="keywordstatus === 0"></v-text-field>
                          </v-flex>
                          <v-flex lg5>
                            <v-btn 
                            v-show=collect_news_val 
                                class="mx-2 elevation-0" 
                                dark 
                                outlined 
                                icon 
                                :color="collect_news_val == false ? 'grey' : '#0471A5'"  
                                @click="collect_news_val  !== false && checkedkeywordCollection(item,index,'NEWS')"
                              >

                                <v-icon class="rounded-icon">{{ item.checknews == true  ? 'mdi-checkbox-marked-circle' : '' }} </v-icon>
                            </v-btn>
                            <v-btn 
                            v-show=collect_twit_val 
                                class="mx-2 elevation-0" 
                                dark 
                                outlined 
                                icon 
                                :color="collect_twit_val === false ? 'grey' : '#0471A5'"  
                                @click="collect_twit_val !== false && checkedkeywordCollection(item,index,'TWITTER')"
                              >

                                <v-icon class="rounded-icon">{{ item.checktwet == true  ? 'mdi-checkbox-marked-circle' : '' }} </v-icon>
                            </v-btn>
                            <v-btn 
                            v-show=collect_ytb_val 
                                class="mx-2 elevation-0" 
                                dark 
                                outlined 
                                icon 
                                :color="collect_ytb_val === false ? 'grey' : '#0471A5'"  
                                @click="collect_ytb_val !== false && checkedkeywordCollection(item,index,'YOUTUBE')"
                              >

                                <v-icon class="rounded-icon">{{ item.checkytb == true  ? 'mdi-checkbox-marked-circle' : '' }} </v-icon>
                            </v-btn>
                            <v-btn 
                            v-show=collect_tiktok_val 
                                class="mx-2 elevation-0" 
                                dark 
                                outlined 
                                icon 
                                :color="collect_tiktok_val === false ? 'grey' : '#0471A5'"  
                                @click="collect_tiktok_val !== false && checkedkeywordCollection(item,index,'TIKTOK')"
                              >

                                <v-icon class="rounded-icon">{{ item.checktiktok== true  ? 'mdi-checkbox-marked-circle' : '' }} </v-icon>
                            </v-btn>
                            
                            <v-btn 
                            v-show=collect_ig_val
                                class="mx-2 elevation-0" 
                                dark 
                                outlined 
                                icon 
                                :color="collect_ig_val === false ? 'grey' : '#0471A5'"  
                                @click="collect_ig_val !== false && checkedkeywordCollection(item,index,'INSTAGRAM')"
                              >
                                <v-icon class="rounded-icon">{{ item.checkig == true  ? 'mdi-checkbox-marked-circle' : '' }} </v-icon>
                            </v-btn>

                            <v-btn 
                            v-show=collect_fb_val
                                class="mx-2 elevation-0" 
                                dark 
                                outlined 
                                icon 
                                :color="collect_fb_val === false ? 'grey' : '#0471A5'"  
                                @click="collect_fb_val !== false && checkedkeywordCollection(item,index,'FACEBOOK')"
                              >
                                <v-icon class="rounded-icon">{{ item.checkfb == true  ? 'mdi-checkbox-marked-circle' : '' }} </v-icon>
                            </v-btn>
                          
                            
                            <v-btn 
                              :class="{
                                'red darken-1': keywordstatus !== 0,  // Apply 'red darken-1' class when status is not 0
                                'grey darken-1': keywordstatus === 0   // Apply 'grey darken-1' class when status is 0
                              }"
                              :color="keywordstatus === 0 ? '#fff' : '#fff'"  
                              @click="keywordstatus !== 0 && remove_edit_keyword(item,index)"
                              icon>
                              <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-row>
                        
                      <!-- end v for dinamis / -->
                        <v-col cols="12" sm="12" md="12">
                          <v-btn 
                          :color="keywordstatus === 0 ? 'grey' : 'blue darken-1'"
                          style="width: 160px;" rounded dark dense  
                           @click="keywordstatus === 0 ? '' : add_edit_keyword()"
                          
                          >
                            <v-icon>mdi-plus</v-icon> Add Keywords
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="py-3">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="closekeywordDialog">
                      Cancel 
                    </v-btn>
                    <v-btn v-show="keywordstatus !== 0"  color="blue darken-1" style="width: 90px;" rounded dark dense @click="saveeditkeyword">
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- delete keyword  -->
              <v-dialog v-model="dialogDelete" width="330px">
                <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
                  <v-avatar class="color-delete my-4" size="62">
                    <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
                  </v-avatar>
                  <div class="text-center text-h6 align-center justify-center font-weight-medium">
                    Confirm Deletion
                  </div>
                  <v-card-text class="align-center justify-center mt-2">
                    Are you sure want to delete keyword?
                  </v-card-text>
                  <v-divider class="mt-4" style=""></v-divider>
                  <v-card-actions class="align-center justify-center">
                    <v-btn rounded class="my-3 btn-info" width="90px" dark @click="deleteItemConfirm">
                      OK
                    </v-btn>
                    <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- end dialog keyword  -->
              <!-- dialog privilage  -->
              <v-dialog v-model="dialogprivilege" max-width="500px">
                <v-card>
                  <v-card-title><span class="text-h6">Update Privilege</span>
                    <span class="name_topic">Topic: {{ name_topic_dialog }}</span> 
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <!-- v for dinamis / -->
                        <v-row class="ma-0 pa-0 ml-3 mt-2" v-for="(item, index) in item_edit_privilage_dinamis" :key="index">
                          <v-flex lg8>
                            <v-select label="Privilege" dense outlined 
                            :items="privilege" 
                            item-text="name_privilege_edit" 
                            item-value="value_privilege_edit"
                            v-model="item.id_role_privilage" ></v-select> 
                          </v-flex>
                          <v-flex lg4>
                            <v-btn class="mx-2 elevation-0" @click="add_edit_privilage" dark outlined icon color="#0471A5"><v-icon>mdi-plus</v-icon></v-btn>
                            <v-btn class="elevation-0"  @click="remove_edit_privilage(item, index)" outlined color="#0471A5" icon><v-icon>mdi-minus</v-icon> </v-btn>
                          </v-flex>
                        </v-row>
                        <!-- end v for dinamis / -->
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="py-3">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="closePrivilageDialog">
                      Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense @click="saveeditprivilage">
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- end dialog privilage  -->
        </v-toolbar>
      </template>
      
      <v-data-table
      :headers="headers"
      :items="topic"
      :search="search"
       sort-by="NO_URUT"
      :sort-desc="[true]"
      class="table-user mt-4 rounded-lg mx-6"
      :loading="tableLoading"
      loading-text="Loading data..."
      >
      
        <!-- Correct slot usage for item.STATUS -->
        <template v-slot:item.GROUP_STATUS_TEXT="{ item }">
          <v-chip :color="getColor(item.GROUP_STATUS_TEXT)"  text-color="white" label small pill>
            {{ item.GROUP_STATUS_TEXT }}
          </v-chip>
        </template>
        <template v-slot:[`item.editstatus`]="{ item }">
          <v-btn class="mr-1" icon v-bind="attrs" v-on="on" @click="informasiItemTopic(item.SEQ_ID)">
            <v-icon small>mdi-information-outline</v-icon>
          </v-btn>
          <v-btn class="mr-1" icon v-bind="attrs" v-on="on" @click="editItemTopic(item.SEQ_ID)">
            <v-icon small>mdi-pencil</v-icon> 
          </v-btn>
          
        </template>
        <!-- button topic action end   -->
        <!-- button keyword action   -->
        <template v-slot:[`item.infokeyword`]="{ item }">
          <v-btn class="mr-1" icon v-bind="attrs" v-on="on" @click="informasiItemKeyword(item.SEQ_ID)">
            <v-icon small>mdi-information-outline</v-icon>
          </v-btn>
          <v-btn class="mr-1" icon v-bind="attrs" v-on="on" @click="editItemKeyword(item.SEQ_ID,item.GROUP_NAME)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn class="mr-1" icon v-bind="attrs" v-on="on" @click="deleteItem(item.SEQ_ID)">
            <v-icon small>mdi-trash-can</v-icon>
          </v-btn>
        </template>
        <!-- button keyword action end  -->
        <!-- button privilage action   -->
        <template v-slot:[`item.editprivilege`]="{ item }">
            <v-btn class="mr-1" icon v-bind="attrs" v-on="on" @click="editItemPrivilage(item.SEQ_ID,item.GROUP_NAME)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
        </template>
        <!-- button privilage action end   -->
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>

      <Notification  ref="alert"></Notification>
  </div>
</template>
<script>
import axios from "axios";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      // keywordcheck: false,
      name_topic_dialog: '',
      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",

      search: '',
      dialog: false,
      dialoginformasitopic: false,
      dialogedittopic: false,
      dialoginformasikeyword: false,
      dialogeditkeyword: false,
      dialogprivilege: false,
      dialogDelete: false,
      // keywordstatusselect: ['Enabled', 'Disabled'],

      
      width_form_keyword: '400px',
      collect_news_val: true,
      collect_twit_val: true,
      collect_ig_val: true,
      collect_fb_val: true,
      collect_tiktok_val: true,
      collect_ytb_val: true,
      
      
      keywordstatus :1,
      keywordstatusedit: [//choice select
              {value_edit: 1, name_edit: "Enabled" },
              {value_edit: 0, name_edit: "Disabled" }
      ],

      topicstatus_topic :1,
      status_topic_insert: [//choice select
              {value_topic: 1, name_topic: "Enabled" },
              {value_topic: 0, name_topic: "Disabled" }
      ],
      topicstatus :1,
      keywordstatusselect: [//choice select
              {value: 1, name: "Enabled" },
              {value: 0, name: "Disabled" }
      ],
      // privilege: ['Admin', 'Staff'],
      
      privilege_insert: [
            {
              value_privilege_insert: '', 
              name_privilege_insert: '' 
            }
      ],
      
      privilege: [
            {
              value_privilege_edit: '', 
              name_privilege_edit: '' 
            }
      ],
      rolestatus: ['Enabled', 'Disabled'],
      keyword: ['Banjir', 'Tanah Longsor', 'Politik'],
      headers: [
        { text: 'No', value: 'NO_URUT' },
        { text: 'Topic Name', value: 'GROUP_NAME' },
        { text: '', value: 'infotopic', sortable: false },
        { text: 'Status', value: 'GROUP_STATUS_TEXT'  },
        { text: '', value: 'editstatus', sortable: false , width: '120px'  },
        { text: 'Keyword', value: 'KEYWORD_ARR' },
        { text: '', value: 'infokeyword', sortable: false, width: '170px' },
        //{ text: 'Seen Privilege', value: 'KEYWORD_PRIVILAGE_ARR', width: '200px'  },
        //{ text: '', value: 'editprivilege', sortable: false },
      ],
      
      item_insert_dinamis: [
        {keywordname : ''}
      ],
      
      item_edit_keyword_dinamis: [
        {keywordname : '',id_keyword : '',status : '',checknews : '',checktwet : '',checkytb : '',checktiktok : '',checkig : ''}
      ],
      
      item_edit_privilage_dinamis: [
        {privilagename : '',id_role_privilage : '',id_privilage : ''}
      ],
      
      
      id_keyword: [],
      topic: [],
      table: [],
      id_topic: '',
      createnametopic: '',
      createdatetopic: '',
      updatenametopic: '',
      updatedatetopic: '',

      
      createnamekeyword: '',
      createdatekeyword: '',
      updatenamekeyword: '',
      updatedatekeyword: '',
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      },
    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Add '+this.$store.state.title : 'Update '+this.$store.state.title
      },
    },
    watch: {
      
      dialogprivilege(val){
        val || this.closeprivilageDialog()
      },
      dialogeditkeyword(val){
        
        val || this.closekeywordDialog()
      },
      
      dialoginformasikeyword(val){
        
        val || this.closeInformasikeywordDialog()
      },
      
      dialoginformasitopic(val){
        val || this.closeInformasiTopicDialog()
      },
      dialogedittopic(val){
        val || this.closeTopicDialog()
      },
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      
      
    getColor(status) {
      return status === 'Disabled' ? 'red' : 'green';
    },
    initialize () {
        this.tableLoading = true;
        axios.get("topic-keyword",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            
            let res = decryptionData(response.data.token);
            // this.topic =  res.data;
          // ➤ Tambahkan nomor urut permanen
          this.topic = res.data.map((item, index) => ({
            ...item,
            NO_URUT: index + 1   // nomor urut tetap
          }));
            // alert(res.send_privilage.length);
            // ----- selected role privilage ----
            let result = '';
            let arr_data = [];
            let result_edit = '';
            let arr_data_edit = [];
            if(res.send_privilage.length > 0){
              for (let i = 0; i <  res.send_privilage.length; i++) {  
                  if(i == 1){
                    this.topic_id = (res.send_privilage[i].SEQ_ID);
                  }
                  result = {
                    name_privilege_insert : res.send_privilage[i].ROLE_NAME,
                    value_privilege_insert : res.send_privilage[i].SEQ_ID
                  };
                  arr_data.push(result);
                  
                  result_edit = {
                    name_privilege_edit : res.send_privilage[i].ROLE_NAME,
                    value_privilege_edit : res.send_privilage[i].SEQ_ID
                  };
                  arr_data_edit.push(result_edit);
              }
              // console.log(arr_data);
              this.privilege_insert= arr_data;
              this.privilege = arr_data_edit;
            }
            // ----- end selected role privilage ----
            setTimeout(() =>{
              this.loading = false
            // end loading 
            },1000)
            this.tableLoading = false;
          })
          .catch((e) => {
              switch (e.response.status) {
               
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      saveinsert () {
        // console.log(this.item_insert_dinamis[0])
        axios.post("/insert-topic-keyword", 
            {
              group_name:this.editedItem.topicname,
              status:this.topicstatus_topic,
              keyword:this.item_insert_dinamis,
              keyword_role_privilage:this.editedItem.topicstatus,
            },
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.initialize();
                this.$router.push('/topickeyword');
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
                this.editedItem = {};
                this.item_insert_dinamis = [
                  { keywordname : '' }
                ];
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    case 400:
                          this.alertFailed = true;
                          this.alert_err_attention =  e.response.data.msg;
                          this.btnload = false
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
      },
      
      close () {
        this.editedItem.topicname = '';
        this.topicstatus_topic = 1
        this.dialog = false
        this.$nextTick(() => {
          this.inputedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      add() {
        this.originalData = null
        this.item_insert_dinamis.push({ keywordname: '' })
      },
      remove(item, index) {
        // alert(index);
        if(index > 0){
          this.item_insert_dinamis.splice(index, 1)
        }else{
          alert('Baris Pertama tidak bisa dihapus');
        }
      },

      // =========================================== topik action =================================
      informasiItemTopic(item){
        // alert(item);
        this.id_topic = item;
        this.loading = true
        axios({
          method: "put",
          url: "/getid-topic-keyword",
          data: {
            seq_id_topic : item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            // const dat = response.data;
            const dat = decryptionData(response.data.token);
            console.log(dat);
            this.createnametopic =dat.SYS_CREATED_BY; 
            this.createdatetopic =dat.SYS_CREATED_DATE; 
            this.updatenametopic =dat.SYS_UPDATED_BY; 
            this.updatedatetopic =dat.SYS_UPDATED_DATE; 
            this.dialoginformasitopic =true;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      
      closeInformasiTopicDialog(){
        this.dialoginformasitopic = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },
      
      editItemTopic (item){
        // alert(item);
        this.id_topic = item;
        this.loading = true
        axios({
          method: "put",
          url: "/getid-topic-keyword",
          data: {
            seq_id_topic : item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            // const dat = response.data;
            
            const dat = decryptionData(response.data.token);
            this.editedItem.topicname = dat.GROUP_NAME;
            this.topicstatus =dat.GROUP_STATUS; 
            this.dialogedittopic =true;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        
      },
      saveedittopic(){
        axios.put("/update-topic-keyword", 
            {
              seq_id_topic:this.id_topic,
              neme_topic:this.editedItem.topicname,
              status_topic:this.topicstatus
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.initialize();
                this.$router.push('/topickeyword');
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
          this.closeTopicDialog();
      },
      closeTopicDialog(){
        this.dialogedittopic = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },
      // =========================================== end topik action =================================
      // =========================================== Keyword action =================================
      informasiItemKeyword(item){
        // alert(item);
        this.id_topic = item;
        this.loading = true
        axios({
          method: "put",
          url: "/get-group-keyword-topic",
          data: {
            seq_id_topic : item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            const dat = decryptionData(response.data.token);
            if(dat.length > 0){
              this.createnamekeyword =dat[0].SYS_CREATED_BY; 
              this.createdatekeyword =dat[0].SYS_CREATED_DATE; 
              this.updatenamekeyword =dat[0].SYS_UPDATED_BY; 
              this.updatedatekeyword =dat[0].SYS_UPDATED_DATE; 
            }
            this.dialoginformasikeyword =true;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      
      closeInformasikeywordDialog(){
        this.dialoginformasikeyword = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },
      
      editItemKeyword (item,topic){
        this.name_topic_dialog = topic
        this.id_topic = item;
        this.loading = true
        axios({
          method: "put",
          url: "/get-group-keyword-topic",
          data: {
            seq_id_topic : item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            // const dat = response.data;
            const dat = decryptionData(response.data.token);
            // alert(response.data.collect_instagram)

            
            const collect_news = (response.data.collect_news);
            const collect_twetter = (response.data.collect_twetter);
            const collect_ytb = (response.data.collect_ytb);
            const collect_tiktok = (response.data.collect_tiktok);
            const collect_instagram = (response.data.collect_instagram);
            const cont_colect_active = (response.data.cont_colect_active);
            const collect_fb = (response.data.collect_fb);

            this.collect_news_val = collect_news;
            this.collect_twit_val = collect_twetter;
            this.collect_ig_val = collect_instagram;
            this.collect_tiktok_val = collect_tiktok;
            this.collect_ytb_val = collect_ytb;
            this.collect_fb_val = collect_fb;
            
            // cont_colect_active
              // alert(cont_colect_active);
            
            if(cont_colect_active == 1){
              this.width_form_keyword = '350px';
            }else  if(cont_colect_active == 2){
              this.width_form_keyword = '450px';
            }else  if(cont_colect_active == 3){
              this.width_form_keyword = '550px';
            }else  if(cont_colect_active == 4){

              this.width_form_keyword = '670px';
            }else  if(cont_colect_active == 5){
              this.width_form_keyword = '790px';

            }else  if(cont_colect_active == 6){
              this.width_form_keyword = '900px';

            }

            if(dat.length > 0){
              //this.keywordstatus =dat[0].KEYWORD_STATUS
              this.keywordstatus =cont_colect_active
            }
            
            // ----- selected role privilage ----
            let result = '';
            let arr_data = [];
            if(dat.length > 0){
              for (let i = 0; i <  dat.length; i++) { 
                this.add_edit_keyword(); 
                  result = {
                    keywordname : dat[i].KEYWORD,
                    id_topic_keyword : dat[i].GROUP_ID,
                    id_keyword : dat[i].SEQ_ID,
                    status : dat[i].KEYWORD_STATUS,
                    checknews : dat[i].NEWS_FLAG,
                    checktwet : dat[i].TWITTER_FLAG,
                    checkytb : dat[i].YTB_FLAG,
                    checktiktok : dat[i].TIKTOK_FLAG,
                    checkig : dat[i].INSTAGRAM_FLAG,
                    checkfb : dat[i].FB_FLAG
                  };
                  arr_data.push(result);
              }
              this.item_edit_keyword_dinamis= arr_data;
            }else{
                  result = {
                    keywordname : '',
                    id_topic_keyword : '',
                    id_keyword : '',
                    status : '',
                    checknews : '',
                    checktwet : '',
                    checkytb : '',
                    checktiktok : '',
                    checkig : '',
                    checkfb : '',
                  };
                  arr_data.push(result);
                  this.item_edit_keyword_dinamis= arr_data;
            }
            // ----- end selected role privilage ----
            this.dialogeditkeyword =true;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        
      },
      
      add_edit_keyword() {
        this.originalData = null
        this.item_edit_keyword_dinamis.push({ keywordname: '',checktwet:'' })
      },
      checkedkeywordCollection(item,index,collection) {
        if(collection == 'NEWS'){
          if(item.checknews == undefined || item.checknews == false){
            item.checknews = false
          }
          if ( item.checknews == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checknews: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checknews: false });
          }
        }else if(collection == 'TWITTER'){
          if(item.checktwet == undefined || item.checktwet == false){
            item.checktwet = false
          }
          if ( item.checktwet == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checktwet: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checktwet: false });
          }

        }else if(collection == 'YOUTUBE'){
          if(item.checkytb == undefined || item.checkytb == false){
            item.checkytb = false
          }
          if ( item.checkytb == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkytb: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkytb: false });
          }
          
        }else if(collection == 'TIKTOK'){
          if(item.checktiktok == undefined || item.checktiktok == false){
            item.checktiktok = false
          }
          if ( item.checktiktok == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checktiktok: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checktiktok: false });
          }
          
        }else if(collection == 'INSTAGRAM'){
          if(item.checkig == undefined || item.checkig == false){
            item.checkig = false
          }
          if ( item.checkig == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkig: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkig: false });
          }
          
        }else if(collection == 'FACEBOOK'){
          if(item.checkfb == undefined || item.checkfb == false){
            item.checkfb = false
          }
          if ( item.checkfb == false) {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkfb: true });

          } else {
            this.$set(this.item_edit_keyword_dinamis, index, { ...item, checkfb: false });
          }
          
        }
        console.log(this.item_edit_keyword_dinamis)

      },
      remove_edit_keyword(item, index) {
        if(index > 0){
          if(item.id_keyword != null){
            axios({
              method: "delete",
              url: "/delete-keyword-topic",
              data: {
                seq_id_keyword: item.id_keyword
              },
              headers:{'auth-token':localStorage.getItem('token_app')},
              dataType: 'json'
            })
            .then((response) => {
              // handle success
              this.editItemKeyword(item.id_topic_keyword);
              console.log(response);
              
              this.initialize();
            })
            .catch(function (error) {
              // handle error
              console.log(error);
            })
          }
          this.item_edit_keyword_dinamis.splice(index, 1)
          
        }else{
          alert('Baris Pertama tidak bisa dihapus');
        }
      },


      
      saveeditkeyword(){
        axios.put("/update-group-keyword-topic", 
            {
              seq_id_topic:this.id_topic,
              keyword:this.item_edit_keyword_dinamis
              // keywors_status:this.keywordstatus
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
            
              // this.initialize()
              // this.$router.push('/topickeyword');
              // // alert('okk');  
              // // console.log(this.item_edit_keyword_dinamis);    
              // console.log(response.data);  
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.initialize();
                this.$router.push('/topickeyword');
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.closekeywordDialog()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
          // this.closekeywordDialog();
      },
      
      closekeywordDialog(){
        this.dialogeditkeyword = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },

      // ============================================ end keyword action ===============================
      // =================================== privilage =================
      editItemPrivilage (item,topic){
        // alert(item);
        this.name_topic_dialog = topic
        console.log(topic)
        this.id_topic = item;
        this.loading = true
        axios({
          method: "put",
          url: "/get-group-privilage-topic",
          data: {
            seq_id_topic : item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            // const dat = response.data;
            const dat = decryptionData(response.data.token);
            // ----- selected role privilage ----
            let result = '';
            let arr_data = [];
            if(dat.length > 0){
              for (let i = 0; i <  dat.length; i++) { 
                this.add_edit_privilage(); 
                  result = {
                    privilagename : dat[i].KEYWORD,
                    id_privilage : dat[i].SEQ_ID,
                    id_role_privilage : dat[i].ROLE_ID,
                    id_topic_keyword : dat[i].GROUP_ID,
                  };
                  arr_data.push(result);
              }
              // this.dialogprivilege= arr_data;
            }else{
                  result = {
                    privilagename : '',
                    id_privilage : '',
                    id_role_privilage : '',
                    id_topic_keyword : ''
                  };
                  arr_data.push(result);

            }
            this.item_edit_privilage_dinamis= arr_data;
            // ----- end selected role privilage ----
            // id_keyword
            this.dialogprivilege =true;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        
      },

      add_edit_privilage() {
        this.originalData = null
        this.item_edit_privilage_dinamis.push({ privilagename: '' ,id_role_privilage : '',id_privilage : ''})
        // this.editIndex = this.item_insert_dinamis.length - 1
      },

      remove_edit_privilage(item, index) {
        // console.log(item.id_privilage);
        // console.log('auu'+index);
       
        if(index > 0){
            if(item.id_privilage != null){
            axios({
              method: "delete",
              url: "/delete-group-privilage-topic",
              data: {
                seq_id_privilage: item.id_privilage
              },
              headers:{'auth-token':localStorage.getItem('token_app')},
              dataType: 'json'
            })
            .then((response) => {
              // handle success
              this.editItemPrivilage(item.id_topic_keyword);
              console.log(response);
              this.initialize();
            })
            .catch(function (error) {
              // handle error
              console.log(error);
            })
          }
          this.item_edit_privilage_dinamis.splice(index, 1)
        }else{
          alert('Baris Pertama tidak bisa dihapus');
        }
      },
      
      saveeditprivilage(){
        axios.put("/update-group-privilage-topic", 
            {
              seq_id_topic:this.id_topic,
              privilage:this.item_edit_privilage_dinamis
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
            
              // this.initialize()
              // this.$router.push('/topickeyword');
              // // alert('okk');  
              // // console.log(this.item_edit_keyword_dinamis);    
              // console.log(response.data);  
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.initialize();
                this.$router.push('/topickeyword');
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.closePrivilageDialog()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
          // this.closePrivilageDialog();
      },
      closePrivilageDialog(){
        this.dialogprivilege = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          
        })
      },
      
      deleteItem (item) {
        this.id_topic = item
        // alert(item);
        this.dialogDelete = true
      },
      
      deleteItemConfirm () {
        this.topic.splice(this.editedIndex, 1)
        axios({
          method: "delete",
          url: "/delete-group-topic",
          data: {
            seq_id_topic: this.id_topic
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          // console.log(response);
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.initialize ();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.closeDelete()
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
          } 
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        // this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.inputedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },


    },
  }
</script>

<style scoped>

.name_topic {
    font-size: 12px; /* Ukuran font lebih kecil */
    font-weight: normal; /* Tidak bold */
    font-style: italic; /* Memiringkan teks */
    margin-left: 3px; 
}
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.tabsitem{
  background-color:#F7F6F4;
}
.btn-info{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-delete
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.overflow-card{
  overflow: scroll;
}
.v-application .mx-2 {
  margin-left: 8px !important;
}
</style>